import _ from 'lodash';
import React, { useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import domtoimage from 'dom-to-image';
import jsPDF from 'jspdf';
import AllInputs from '../../../../inputs/AllInputs';

const InspectionScottAutoGroup = () => {
  const dispatch = useDispatch();
  const current_dealership = useSelector((state) => state.settings_dealerships.current_dealership);
  const active_vehicle = useSelector((state) => state.settings_refresh.active_vehicle);
  const current_tab = useSelector((state) => state.settings_nav.menus.vehicle_tab);

  if (!active_vehicle) {
    return <div>No active vehicle selected.</div>;
  }

  const { topRows, firstRows, fields } = useMemo(() => {
    if (current_tab === 'tab_scott_certified') {
      return {
        topRows: [],
        fields: ['Pass', 'Recommend', 'Required', 'Completed'],
        firstRows: [
          // Vehicle History
          'Vehicle History',
          'VIN # Inspection',
          'Service Recalls Performed',
          'Emissions - Scan Vehicle for Diagnostic Codes',
          // Road Test
          'Road Test',
          'Engine Starts and Idles Properly',
          'Remote Start System Operation',
          'Engine Accelerates and Cruises Properly',
          'Engine Noise',
          'Transmission/Drivetrain Shift Quality/Noise',
          'Clutch Operation',
          'Power Steering',
          'Struts and Shocks',
          'Brakes/ABS',
          'Cruise Control/Driver Support Systems/BSI',
          'Gauges Functioning Properly',
          'Driver Memory Settings Functioning Properly',
          'No Abnormal Wind Noise',
          // Exterior
          'Exterior',
          'Body Panel and Bumper Inspection',
          'Doors, Hood, Trunk/Tailgate and Roof Inspection/Alignment',
          'Door, Hood and Tailgate Function, Prop Rod/Strut Operation',
          'Grille, Trim and Roof Rack Inspection',
          'Running Boards',
          'Windshields and all Exterior Glass (Including Mirrors)',
          'Outside Mirror Function and Operation',
          'All Exterior Lighting and Hazard Function',
          'Auto On/Off Lighting',
          'Trailer Lamp Connector Operation',
          // Interior
          'Interior',
          'Airbags',
          'Safety Belts',
          'Audio System and Speaker Function',
          'Antenna',
          'Navigation System (clear and reset)',
          'Air Conditioning System',
          'Heating System',
          'Defog / Defrost',
          'Clock',
          'Tilt / Telescopic Steering Wheel/Column Lock',
          'Steering Wheel Controls',
          'Horn',
          'Warning Chimes',
          'Instrument Panel Warning Indicators',
          'Wiper/Washer Function',
          'Interior Courtesy, Dome and Map Lights',
          'Rear-View/Auto Dimming Rear-View Mirrors',
          'Rear-View Camera/Parking Sensors (if applicable)',
          'Rear Entertainment (if applicable)',
          'Power Outlets',
          'Glovebox and Center Console/Armrest',
          'Sunvisors, Vanity Mirrors and Lights',
          'Adjustable Pedals (if applicable)',
          'Door Handles and Release Mechanisms',
          'Remote Entry and Push Button Start Systems',
          'Door Locks',
          'Child Safety Locks',
          'Seat and Head Restraint Adjustment',
          'Folding Seats',
          'Heated and Ventilated Seats (if applicable)',
          'Integrated Child Safety Seats',
          'Sunroof / Moonroof (if applicable)',
          'Convertible Top (if applicable)',
          'Window Function and Controls',
          'Trunk/Fuel Door Release',
          'Luggage Compartment Light',
          'Vehicle Jack and/or Tool Kit',
          'Spare Tire',
          // Under Hood
          'Under Hood',
          'Engine Oil / Filter Change and Chassis Lube',
          'Cooling System Components (Pressure Test)',
          'Brake Fluid',
          'Transmission/Drivetrain Fluid Condition or Leaks',
          'Power Steering Fluid Condition or Leaks',
          'Washer Fluid',
          'Belts, Hoses, Lines and Fittings',
          'Wiring',
          'Water, Sludge or Engine Coolant in Oil',
          'Oil Pressure',
          'Inspect Turbocharger/Intercooler (if applicable)',
          'Cooling Fans, Clutches and Motors',
          'Water Pump',
          'Fuel Pump Pressure and Function',
          'Fuel Filter',
          'Engine Air Filter',
          'Starter Operation',
          'Ignition System',
          'Battery',
          'Alternator Output',
          'Diesel Glow Plug System (if applicable)',
          'Hybrid Cooling System (if applicable)',
          'Electronically Controlled Powertrain Mounts (if applicable)',
          'Infotainment System and Display (if applicable)',
          // Underbody
          'Underbody',
          'Tires/Wheels',
          'Frame Damage',
          'Fuel Delivery System',
          'Exhaust System Condition',
          'Transmission / Drivetrain Condition (if applicable)',
          '4x4 Hub Operation (if applicable)',
          'Universal Joints, CV Joints and Boots',
          'Differential / Drive Axles',
          'Tire Tread Depth',
          'Tire Wear Pattern',
          'Tire Pressure (Set to Manufacturers Spec.)',
          'Tire Pressure Monitoring System',
          'Wheels',
          'Wheel Covers and Center Caps',
          'Rack and Pinion, Linkage and Boots',
          'Control Arms, Bushings and Ball Joints',
          'Tie-Rods and Idler Arm',
          'Sway Bars, Links and Bushings',
          'Springs',
          'Shocks and Struts',
          'Wheel Alignment',
          'Power Steering Pump, Lines and Hoses',
          'Brake Calipers and Wheel Cylinders',
          'Brake Pads/Shoes',
          'Brake Rotors/Drums',
          'Brake Lines, Hoses and Fittings',
          'Parking Brake Operation',
          'Brake Master Cylinder and Booster',
        ],
      };
    } if (current_tab === 'tab_inspection') {
      return {
        topRows: [],
        fields: ['Pass', 'Recommend', 'Required', 'Notes', 'Labor Hours', 'Parts', 'Total', 'Completed'],
        firstRows: [
          // Vehicle History
          'Vehicle History',
          'VIN # Inspection',
          'Service Recalls Performed',
          'Emissions - Scan Vehicle for Diagnostic Codes',
          // Road Test
          'Road Test',
          'Engine Starts and Idles Properly',
          'Remote Start System Operation',
          'Engine Accelerates and Cruises Properly',
          'Engine Noise',
          'Transmission/Drivetrain Shift Quality/Noise',
          'Clutch Operation',
          'Power Steering',
          'Struts and Shocks',
          'Brakes/ABS',
          'Gauges Functioning Properly',
          // Under Hood
          'Under Hood',
          'Engine Oil / Filter Change and Chassis Lube',
          'Cooling System Components (Pressure Test)',
          'Cooling Fans, Clutches and Motors',
          'Water pump',
          'Transmission/Drivetrain Fluid Condition or Leaks',
          '4x4 Hub Operation (if applicable)',
          'Universal Joints, CV Joints and Boots',
          'Brake Master Cylinder and Booster',
          'Brake Fluid',
          'Brake Rotors/Drums',
          'Brake Lines, Hoses and Fittings',
          'Parking Brake Operation',
          'Brake Pads/Shoes',
          'Power Steering Pump, Lines and Hoses',
          'Belts, Hoses, Lines and Fittings',
          'Inspect Turbocharger/Intercooler (if applicable)',
          'Engine Air Filter',
          'Starter Operation',
          'Battery',
          'Alternator Output',
          'Exhaust System Condition',
          'Tire Tread Depth',
          'Tire Wear Pattern',
          'Wheel Alignment',
          'Tire Pressure (Set to Manufacturers Spec.)',
          'Tire Pressure Monitoring System',
          'Rack and Pinion, Linkage and Boots',
          'Control Arms, Bushings and Ball Joints',
          'Tie-Rods and Idler Arm',
          'Sway Bars, Links and Bushings',
          'Springs',
          'Shocks and Struts',
          'Frame Damage',
          // Exterior
          'Exterior',
          'Doors, Hood, Trunk/Tailgate and Roof Inspection/Alignment',
          'Windshields and all Exterior Glass (Including Mirrors)',
          'All Exterior Lighting and Hazard Function',
          'Trailer Lamp Connector Operation',
          // Interior
          'Interior',
          'Airbags',
          'Safety Belts',
          'Audio System and Speaker Function',
          'Antenna',
          'Navigation System (clear and reset)',
          'Air Conditioning System',
          'Heating System',
          'Defog / Defrost',
          'Horn',
          'Wiper/Washer Function',
          'Door Locks',
          'Window Function and Controls',
          'Child Safety Locks',
          'Sunroof / Moonroof (if applicable)',
          'Convertible Top (if applicable)',
          'Trunk/Fuel Door Release',
          'Spare Tire',
        ],
      };
    }
    return {
      topRows: ['custom_inspection1', 'custom_inspection2', 'custom_inspection3', 'custom_inspection4'],
      fields: ['Pass', 'Recommend', 'Required', 'Notes', 'Labor Hours', 'Parts', 'Total', 'Completed'],
      firstRows: [
        'custom_inspection1',
        'custom_inspection2',
        'custom_inspection3',
        'custom_inspection4',
        'Tread Depth Front',
        'Tread Depth Rear',
        'Pad Life Front',
        'Pad Life Rear',
        'Rotors',
        'Suspension',
        'Axle/Bools/U Joints',
        'Steering Components',
        'Shocks/Strusts',
        'Oil Leaks',
        'Tranny Leaks/Flush',
        'Exaust',
        'Power Steering',
        'Filters',
        'Chassis Damage',
        "Owner's Manual",
        'Lube Doors/Hinges',
        'Jack Assembly',
        'Spare Tire',
        'Engine Operation',
        'Cruise',
        'Alignment',
        'Steering Wheel Center',
        'Interior Lights',
        'Power Accessories',
        'A/C & Heater',
        'Seat Belts',
        'Keys/Fobs',
      ],
    };
  }, [current_tab]);

  const vehiclePropertiesMap = useMemo(() => {
    const map = {};
    active_vehicle.vehicle_properties.forEach((prop) => {
      map[prop.key] = prop;
    });
    return map;
  }, [active_vehicle.vehicle_properties]);

  const vehicleProperty = (name) => vehiclePropertiesMap[name] || { value: '', user_name: '', updated_at: '' };

  const renderCustomInput = (row, customProp, setdisabled) => {
    if (!row.includes('custom')) return null;
    const customFields = {
      custom_inspection1: 'custom_inspection1',
      custom_inspection2: 'custom_inspection2',
      custom_inspection3: 'custom_inspection3',
      custom_inspection4: 'custom_inspection4',
    };
    const fieldName = customFields[row];
    if (!fieldName) return null;
    const prop = customProp(fieldName);
    return (
      <AllInputs
        key={row}
        value={prop.value || ''}
        type="text"
        name={row}
        parentid={active_vehicle.id}
        updatetype="vehicleproperty"
        setdisabled={setdisabled}
        user_name={prop.user_name}
        updated_at={prop.updated_at}
        vehicle={active_vehicle}
      />
    );
  };

  const renderTreadOrPadInput = (row, setdisabled) => {
    if (!['Tread Depth Front', 'Tread Depth Rear', 'Pad Life Front', 'Pad Life Rear', 'Tire Tread Depth', 'Brake Pads/Shoes'].includes(row)) return null;

    const sides = {
      'Tread Depth Front': ['Tread Depth Front_left', 'Tread Depth Front_right'],
      'Tread Depth Rear': ['Tread Depth Rear_left', 'Tread Depth Rear_right'],
      'Pad Life Front': ['Pad Life Front_left', 'Pad Life Front_right'],
      'Pad Life Rear': ['Pad Life Rear_left', 'Pad Life Rear_right'],
      'Tire Tread Depth': ['Tire Tread Depth_left_front', 'Tire Tread Depth_right_front', 'Tire Tread Depth_left_rear', 'Tire Tread Depth_right_rear'],
      'Brake Pads/Shoes': ['Brake Pads/Shoes_left_front', 'Brake Pads/Shoes_right_front', 'Brake Pads/Shoes_left_rear', 'Brake Pads/Shoes_right_rear'],
    };

    const measurements = sides[row].map((name) => vehicleProperty(name));
    const isFourInputs = measurements.length === 4; // For Tire Tread Depth and Brake Pads/Shoes

    return (
      <div key={row} className="row">
        <div className="col-md-12">{row}</div>
        <div className={isFourInputs ? 'col-md-3' : 'col-md-6'}>
          <label>{isFourInputs ? 'L/F' : 'Left'}</label>
          <AllInputs
            value={measurements[0].value || ''}
            type="text"
            name={sides[row][0]}
            parentid={active_vehicle.id}
            updatetype="vehicleproperty"
            setdisabled={setdisabled}
            user_name={measurements[0].user_name}
            updated_at={measurements[0].updated_at}
            vehicle={active_vehicle}
          />
        </div>
        <div className={isFourInputs ? 'col-md-3' : 'col-md-6'}>
          <label>{isFourInputs ? 'R/F' : 'Right'}</label>
          <AllInputs
            value={measurements[1].value || ''}
            type="text"
            name={sides[row][1]}
            parentid={active_vehicle.id}
            updatetype="vehicleproperty"
            setdisabled={setdisabled}
            user_name={measurements[1].user_name}
            updated_at={measurements[1].updated_at}
            vehicle={active_vehicle}
          />
        </div>
        {isFourInputs && (
          <>
            <div className="col-md-3">
              <label>L/R</label>
              <AllInputs
                value={measurements[2].value || ''}
                type="text"
                name={sides[row][2]}
                parentid={active_vehicle.id}
                updatetype="vehicleproperty"
                setdisabled={setdisabled}
                user_name={measurements[2].user_name}
                updated_at={measurements[2].updated_at}
                vehicle={active_vehicle}
              />
            </div>
            <div className="col-md-3">
              <label>R/R</label>
              <AllInputs
                value={measurements[3].value || ''}
                type="text"
                name={sides[row][3]}
                parentid={active_vehicle.id}
                updatetype="vehicleproperty"
                setdisabled={setdisabled}
                user_name={measurements[3].user_name}
                updated_at={measurements[3].updated_at}
                vehicle={active_vehicle}
              />
            </div>
          </>
        )}
      </div>
    );
  };

  const onPrint = async () => {
    try {
      const print_page = document.getElementById('print-inspection');
      const dataUrl = await domtoimage.toPng(print_page);
      const pdf = new jsPDF();
      pdf.addImage(dataUrl, 'PNG', 20, 5, 175, 290);
      pdf.save('vehicle_inspection.pdf');
    } catch (error) {
      console.error('Failed to generate PDF:', error);
      alert('Failed to generate PDF. Please try again.');
    }
  };

  const separators = [
    'Vehicle History',
    'Road Test',
    'Exterior',
    'Interior',
    'Under Hood',
    'Underbody',
  ];

  const rows = firstRows.map((row) => {
    if (separators.includes(row)) {
      return (
        <tr key={row}>
          <th colSpan={fields.length + 1} className="text-uppercase bg-success text-lg pad-top-half pad-bottom-half">
            {row}
          </th>
        </tr>
      );
    }

    const fieldNames = {
      pass: `${row}_Pass`,
      recommend: `${row}_Recommend`,
      required: `${row}_Required`,
      notes: `${row}_Notes`,
      labor_hours: `${row}_Labor Hours`,
      parts: `${row}_Parts`,
      total: `${row}_Total`,
      completed: `${row}_Completed`,
    };
    const fieldProps = Object.fromEntries(
      Object.entries(fieldNames).map(([key, name]) => [key, vehicleProperty(name)])
    );
    const setdisabled = false;

    const firstColumn = renderCustomInput(row, vehicleProperty, setdisabled) || renderTreadOrPadInput(row, setdisabled) || row;

    return (
      <tr key={fieldNames.pass}>
        <th className="text-uppercase">{firstColumn}</th>
        <td className={fieldProps.pass.value === 'true' ? 'bg-green text-center pad-top-half' : 'text-center pad-top-half'}>
          <AllInputs
            value={fieldProps.pass.value || ''}
            type="userstamp"
            name={fieldNames.pass}
            parentid={active_vehicle.id}
            updatetype="vehicleproperty"
            setdisabled={setdisabled}
            user_name={fieldProps.pass.user_name}
            updated_at={fieldProps.pass.updated_at}
            vehicle={active_vehicle}
          />
        </td>
        {fields.includes('Recommend') && (
          <td className={fieldProps.recommend.value === 'true' ? 'bg-yellow text-center pad-top-half' : 'text-center pad-top-half'}>
            <AllInputs
              value={fieldProps.recommend.value || ''}
              type="userstamp"
              name={fieldNames.recommend}
              parentid={active_vehicle.id}
              updatetype="vehicleproperty"
              setdisabled={setdisabled}
              user_name={fieldProps.recommend.user_name}
              updated_at={fieldProps.recommend.updated_at}
              vehicle={active_vehicle}
            />
          </td>
        )}
        <td className={fieldProps.required.value === 'true' ? 'bg-red text-center pad-top-half' : 'text-center pad-top-half'}>
          <AllInputs
            value={fieldProps.required.value || ''}
            type="userstamp"
            name={fieldNames.required}
            parentid={active_vehicle.id}
            updatetype="vehicleproperty"
            setdisabled={setdisabled}
            user_name={fieldProps.required.user_name}
            updated_at={fieldProps.required.updated_at}
            vehicle={active_vehicle}
          />
        </td>
        {fields.includes('Notes') && (
          <td>
            <AllInputs
              value={fieldProps.notes.value || ''}
              type="textarea"
              name={fieldNames.notes}
              parentid={active_vehicle.id}
              updatetype="vehicleproperty"
              setdisabled={setdisabled}
              user_name={fieldProps.notes.user_name}
              updated_at={fieldProps.notes.updated_at}
              vehicle={active_vehicle}
            />
          </td>
        )}
        {fields.includes('Labor Hours') && (
          <td>
            <AllInputs
              value={fieldProps.labor_hours.value || ''}
              type="text"
              name={fieldNames.labor_hours}
              parentid={active_vehicle.id}
              updatetype="vehicleproperty"
              setdisabled={setdisabled}
              user_name={fieldProps.labor_hours.user_name}
              updated_at={fieldProps.labor_hours.updated_at}
              vehicle={active_vehicle}
            />
          </td>
        )}
        {fields.includes('Parts') && (
          <td>
            <AllInputs
              value={fieldProps.parts.value || ''}
              type="text"
              name={fieldNames.parts}
              parentid={active_vehicle.id}
              updatetype="vehicleproperty"
              setdisabled={setdisabled}
              user_name={fieldProps.parts.user_name}
              updated_at={fieldProps.parts.updated_at}
              vehicle={active_vehicle}
            />
          </td>
        )}
        {fields.includes('Total') && (
          <td>
            <AllInputs
              value={fieldProps.total.value || ''}
              type="text"
              name={fieldNames.total}
              parentid={active_vehicle.id}
              updatetype="vehicleproperty"
              setdisabled={setdisabled}
              user_name={fieldProps.total.user_name}
              updated_at={fieldProps.total.updated_at}
              vehicle={active_vehicle}
            />
          </td>
        )}
        {fields.includes('Completed') && (
          <td className={fieldProps.completed.value === 'true' ? 'bg-green text-center' : 'text-center'}>
            <AllInputs
              value={fieldProps.completed.value || ''}
              type="userstamp"
              name={fieldNames.completed}
              parentid={active_vehicle.id}
              updatetype="vehicleproperty"
              setdisabled={setdisabled}
              user_name={fieldProps.completed.user_name}
              updated_at={fieldProps.completed.updated_at}
              vehicle={active_vehicle}
            />
          </td>
        )}
      </tr>
    );
  });

  return (
    <>
      <button onClick={onPrint} className="btn btn-success float-left">
        Print
      </button>
      <div className="container-fluid" id="print-inspection">
        <div className="row">
          <div className="container col-xs-12 column no-more-tables ui-grid-a">
            <div className="vehicle-header mb-3 p-3 bg-light border rounded">
              <div className="d-flex justify-content-between align-items-center">
                <h2 className="mb-0">
                  {active_vehicle.year} {active_vehicle.make} {active_vehicle.model}
                </h2>
              </div>
              <div className="d-flex justify-content-between mt-2">
                <span><strong>Stock:</strong> {active_vehicle.stock} <strong>VIN:</strong> {active_vehicle.vin}</span>
              </div>
            </div>
            <table
              className="col-xs-12 table-bordered table-striped inspection-table"
              style={{ width: '94%', margin: 'auto' }}
            >
              <thead className="thead-light">
                <tr>
                  <th className="text-center col-xs-2" style={{ width: '200px' }} />
                  <th className="text-center col-xs-1" style={{ width: '90px' }}>
                    Pass
                  </th>
                  {fields.includes('Recommend') && (
                    <th className="text-center col-xs-1" style={{ width: '90px' }}>
                      Recommend
                    </th>
                  )}
                  <th className="text-center col-xs-1" style={{ width: '90px' }}>
                    Required
                  </th>
                  {fields.includes('Notes') && (
                    <th className="text-center col-xs-2" style={{ width: '180px' }}>
                      Notes
                    </th>
                  )}
                  {fields.includes('Labor Hours') && (
                    <th className="text-center col-xs-1" style={{ width: '45px' }}>
                      Labor Hours
                    </th>
                  )}
                  {fields.includes('Parts') && (
                    <th className="text-center col-xs-1" style={{ width: '45px' }}>
                      Parts
                    </th>
                  )}
                  {fields.includes('Total') && (
                    <th className="text-center col-xs-1" style={{ width: '45px' }}>
                      Total
                    </th>
                  )}
                  {fields.includes('Completed') && (
                    <th className="text-center col-xs-1" style={{ width: '90px' }}>
                      Completed
                    </th>
                  )}
                </tr>
              </thead>
              <tbody className="detail_slip_form">{rows}</tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default InspectionScottAutoGroup;